import React from 'react';
// import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Input from '@material-ui/core/Input';
import Typography from '@material-ui/core/Typography';
import Checkbox from '@material-ui/core/Checkbox';
import clsx from 'clsx';
import { Button, TextField } from '@material-ui/core';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
// import './styles.css';

const useStyles = makeStyles((theme) => ({
    question: {
        color: '#111',
        fontFamily: 'Rubik',
        fontSize: '15px',
        fontWeight: 500,
    },
    italichead: {
        fontFamily: 'Rubik',
        fontSize: '15px',
        fontWeight: 500,
        fontStyle: 'italic',
        color: '#5d5d5d',
        marginBottom: '10px',
    },
    heading1: {
        fontFamily: 'Rubik',
        color: '#111',
        fontSize: '18px',
        fontWeight: 500,
    },
    subheading: {
        fontSize: '12px',
        color: '#4c4c4d',
        fontFamily: 'Rubik',
        fontWeight: 500,
    },
    button: {
        fontSize: '15px !important',
        fontWeight: '400 !important',
        textTransform: 'capitalize',
        padding: '6px 10px',
        letterSpacing: 'normal',
        width: '100%',
    },
    btnspace: {
        // marginTop: '25px',
        width: '100%',
    },
    inlineDisplay: {
        listStyle: 'none',
        padding: '0',
        '& li': {
            display: 'inline-block',
            padding: '0px 10px 0px 0px',
            color: '#7779ba',
        },
        '& label': {
            marginLeft: '0',
        },
    },
    inlineDisplay1: {
        listStyle: 'none',
        padding: '0',
        '& li': {
            display: 'inline-block',
            padding: '0px 10px 0px 0px',
            color: '#7779ba',
            width: '50%',
        },
        '& label': {
            marginLeft: '0',
        },
    },
}));
function StyledRadio(props) {
    const classes = useStyles();

    return (
        <Radio
            className={classes.root}
            disableRipple
            color="default"
            checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
            icon={<span className={classes.icon} />}
            {...props}
        />
    );
}

const CaroChecklist = () => {
    const classes = useStyles();
    const [values, setValues] = React.useState({
        name: '',
        pan: '',
        value: '',
    });

    return (
        <>
            <Card className="client-card">
                <CardContent className="client-heading">
                    <Typography variant="h5">CARO Applicability</Typography>
                </CardContent>
                <CardContent>
                    <Grid container spacing={3} className="main-container">
                        <Grid item xs={12} sm={12}>
                            <Typography className={classes.heading1}>Legal Structure of the Client</Typography>
                            <Typography className={classes.question}>Is the client a company?</Typography>
                            {/* <Typography className={classes.subheading}></Typography> */}
                            {/* <Typography className={classes.subheading}>ET Reviews</Typography> */}
                            <FormControl component="fieldset">
                                <RadioGroup
                                    disabled
                                    defaultValue="Yes"
                                    aria-label="yes-no"
                                    name="customized-radios"
                                    className="radio-option"
                                >
                                    <ul className={classes.inlineDisplay}>
                                        <li>
                                            <FormControlLabel value="Yes" control={<StyledRadio />} label="Yes" />
                                        </li>
                                        <li>
                                            <FormControlLabel value="No" control={<StyledRadio />} label="No" />
                                        </li>
                                    </ul>
                                </RadioGroup>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <Typography className={classes.question}>
                                Is the client banking or insurance company/ small or OPC/ Sec 8 Company
                            </Typography>
                            {/* <Typography className={classes.subheading}>ET Reviews</Typography> */}
                            <FormControl component="fieldset">
                                <RadioGroup
                                    disabled
                                    defaultValue="Yes"
                                    aria-label="yes-no"
                                    name="customized-radios"
                                    className="radio-option"
                                >
                                    <ul className={classes.inlineDisplay}>
                                        <li>
                                            <FormControlLabel value="Yes" control={<StyledRadio />} label="Yes" />
                                        </li>
                                        <li>
                                            <FormControlLabel value="No" control={<StyledRadio />} label="No" />
                                        </li>
                                    </ul>
                                </RadioGroup>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <Typography className={classes.heading1}>Threshold Test For Applicability on Private Companies</Typography>
                            <Typography className={classes.italichead}>If client is private limited company</Typography>
                            <Typography className={classes.question}>
                                Is paid up capital and reserves greater than 1 crore rupees on Balance Sheet Date?
                            </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            {/* <div>
                            <Typography className={classes.heading}>Other clauses</Typography>
                            </div> */}
                            <FormControl fullWidth>
                                <TextField
                                    label="Enter value"
                                    className="textfieldBottomLine mbtextField10"
                                    defaultValue="Enter value"
                                    multiline
                                    rows={1}
                                    // disabled={!checkboxes.includes(question.questionId)}
                                    // onChange={e => {
                                    //   onAnswer && onAnswer(question.questionId, e.target.value)
                                    // }}
                                />
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <FormControl component="fieldset">
                                <RadioGroup
                                    disabled
                                    defaultValue="Yes"
                                    aria-label="yes-no"
                                    name="customized-radios"
                                    className="radio-option mb15"
                                >
                                    <ul className={classes.inlineDisplay}>
                                        <li>
                                            <FormControlLabel value="Yes" control={<StyledRadio />} label="Yes" />
                                        </li>
                                        <li>
                                            <FormControlLabel value="No" control={<StyledRadio />} label="No" />
                                        </li>
                                    </ul>
                                </RadioGroup>
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={12}>
                            <Typography className={classes.question}>
                                Whether the Company does has loan outstanding exceeding 1 crore rupees from any bank or financial
                                institution, at any point of time during the year?
                            </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth>
                                <TextField
                                    label="Enter value"
                                    className="textfieldBottomLine mbtextField10"
                                    defaultValue="Enter value"
                                    multiline
                                    rows={1}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControl component="fieldset">
                                <RadioGroup
                                    disabled
                                    defaultValue="Yes"
                                    aria-label="yes-no"
                                    name="customized-radios"
                                    className="radio-option mb15"
                                >
                                    <ul className={classes.inlineDisplay}>
                                        <li>
                                            <FormControlLabel value="Yes" control={<StyledRadio />} label="Yes" />
                                        </li>
                                        <li>
                                            <FormControlLabel value="No" control={<StyledRadio />} label="No" />
                                        </li>
                                    </ul>
                                </RadioGroup>
                            </FormControl>
                        </Grid>
                        <Grid item container spacing={3}>
                            <Grid item sm={12} className={classes.fullWidth}>
                                <Typography className={classes.question}>
                                    Whether turnover is greater than 10 crore rupees as declared in Financials ?
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <TextField
                                        label="Enter value"
                                        className="textfieldBottomLine mbtextField10"
                                        defaultValue="Enter value"
                                        multiline
                                        rows={1}
                                    />
                                </FormControl>
                            </Grid>

                            <Grid item xs={6} sm={6}>
                                <div>
                                    <FormControl component="fieldset">
                                        <RadioGroup
                                            disabled
                                            defaultValue="Yes"
                                            aria-label="yes-no"
                                            name="customized-radios"
                                            className="radio-option mb15"
                                        >
                                            <ul className={classes.inlineDisplay}>
                                                <li>
                                                    <FormControlLabel value="Yes" control={<StyledRadio />} label="Yes" />
                                                </li>
                                                <li>
                                                    <FormControlLabel value="No" control={<StyledRadio />} label="No" />
                                                </li>
                                            </ul>
                                        </RadioGroup>
                                    </FormControl>
                                </div>
                            </Grid>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
            {/* Card 2 starts */}
            <Card className="client-card">
                <CardContent className="client-heading">
                    <Typography variant="h5">CARO Checklist</Typography>
                </CardContent>
                <CardContent>
                    {/* <CardHeader className="borderBottomLine ptb24" title="CARO Checklist" /> */}
                    <Grid container spacing={3} className="main-container">
                        <Grid item xs={12} sm={12}>
                            <Typography className={classes.question}>
                                Whether the company is maintaining proper records showing full particulars, including quantitative details
                                and situation of Property, Plant and Equipment;
                            </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControl component="fieldset">
                                <RadioGroup
                                    disabled
                                    defaultValue="Yes"
                                    aria-label="yes-no"
                                    name="customized-radios"
                                    className="radio-option mb15"
                                >
                                    <ul className={classes.inlineDisplay}>
                                        <li>
                                            <FormControlLabel value="Yes" control={<StyledRadio />} label="Yes" />
                                        </li>
                                        <li>
                                            <FormControlLabel value="No" control={<StyledRadio />} label="No" />
                                        </li>
                                        <li>
                                            <FormControlLabel value="NA" control={<StyledRadio />} label="NA" />
                                        </li>
                                    </ul>
                                </RadioGroup>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth>
                                <TextField
                                    label="Reporting"
                                    className="textfieldBottomLine mbtextField10"
                                    defaultValue="Enter Reporting"
                                    multiline
                                    rows={1}
                                />
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth>
                                <TextField
                                    label="Remarks"
                                    className="textfieldBottomLine mbtextField10"
                                    defaultValue="Enter Remarks"
                                    multiline
                                    rows={1}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControl className={classes.btnspace}>
                                <Button variant="outlined" color="primary" className={classes.button}>
                                    Attach document
                                </Button>
                            </FormControl>
                        </Grid>
                    </Grid>

                    <Grid container spacing={3} className="main-container">
                        <Grid item xs={12} sm={12}>
                            <Typography className={classes.question}>
                                Whether records of Property, Plant and Equipment are maintained showing the detailed particulars of :
                                Classification, Location, Cost of asset, Date of purchase, Depreciation, Etc have been Furnished
                            </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth>
                                <TextField
                                    label="Remarks"
                                    className="textfieldBottomLine mbtextField10"
                                    defaultValue="Enter Remarks"
                                    multiline
                                    rows={1}
                                />
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth>
                                <TextField
                                    label="Reporting"
                                    className="textfieldBottomLine mbtextField10"
                                    defaultValue="Enter Reporting"
                                    multiline
                                    rows={1}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControl className={classes.btnspace}>
                                <Button variant="outlined" color="primary" className={classes.button}>
                                    Attach document
                                </Button>
                            </FormControl>
                        </Grid>
                    </Grid>
                    <Grid container spacing={3} className="main-container">
                        <Grid item xs={12} sm={12}>
                            <Typography className={classes.question}>Check if Books and Register Reconcile</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth>
                                <TextField
                                    label="Remarks"
                                    className="textfieldBottomLine mbtextField10"
                                    defaultValue="Enter Remarks"
                                    multiline
                                    rows={1}
                                />
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth>
                                <TextField
                                    label="Reporting"
                                    className="textfieldBottomLine mbtextField10"
                                    defaultValue="Enter Reporting"
                                    multiline
                                    rows={1}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControl className={classes.btnspace}>
                                <Button variant="outlined" color="primary" className={classes.button}>
                                    Attach document
                                </Button>
                            </FormControl>
                        </Grid>
                    </Grid>
                    <Grid container spacing={3} className="main-container">
                        <Grid item xs={12} sm={12}>
                            <Typography className={classes.question}>
                                Whether these Property, Plant and Equipment have been physically verified by the management at reasonable
                                intervals; whether any material discrepancies were noticed on such verification and if so, whether the same
                                have been properly dealt with in the books of account;
                            </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth>
                                <TextField
                                    label="Remarks"
                                    className="textfieldBottomLine mbtextField10"
                                    defaultValue="Enter Remarks"
                                    multiline
                                    rows={1}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth>
                                <TextField
                                    label="Reporting"
                                    className="textfieldBottomLine mbtextField10"
                                    defaultValue="Enter Reporting"
                                    multiline
                                    rows={1}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControl className={classes.btnspace}>
                                <Button variant="outlined" color="primary" className={classes.button}>
                                    Attach document
                                </Button>
                            </FormControl>
                        </Grid>
                    </Grid>
                    <Grid container spacing={3} className="main-container">
                        <Grid item xs={12} sm={12}>
                            <Typography className={classes.question}>
                                Whether the title deeds of all the immovable properties are held in the name of the company, if not, provide
                                the details in Annexure 1
                            </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControl component="fieldset">
                                <RadioGroup
                                    disabled
                                    defaultValue="Yes"
                                    aria-label="yes-no"
                                    name="customized-radios"
                                    className="radio-option mb15"
                                >
                                    <ul className={classes.inlineDisplay}>
                                        <li>
                                            <FormControlLabel value="Yes" control={<StyledRadio />} label="Yes" />
                                        </li>
                                        <li>
                                            <FormControlLabel value="No" control={<StyledRadio />} label="No" />
                                        </li>
                                        <li>
                                            <FormControlLabel value="NA" control={<StyledRadio />} label="NA" />
                                        </li>
                                    </ul>
                                </RadioGroup>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth>
                                <TextField
                                    label="Reporting"
                                    className="textfieldBottomLine mbtextField10"
                                    defaultValue="Enter Reporting"
                                    multiline
                                    rows={1}
                                />
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth>
                                <TextField
                                    label="Remarks"
                                    className="textfieldBottomLine mbtextField10"
                                    defaultValue="Enter Remarks"
                                    multiline
                                    rows={1}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <ul className={classes.inlineDisplay1}>
                                <li>
                                    <div className={classes.fullWidth}>
                                        <FormControl className={classes.btnspace}>
                                            <Button variant="outlined" color="primary" className={classes.button}>
                                                Download Annexure 1
                                            </Button>
                                        </FormControl>
                                    </div>
                                </li>
                                <li>
                                    <div className={classes.fullWidth}>
                                        <FormControl className={classes.btnspace}>
                                            <Button variant="outlined" color="primary" className={classes.button}>
                                                Upload Annexure 1
                                            </Button>
                                        </FormControl>
                                    </div>
                                </li>
                            </ul>
                        </Grid>
                    </Grid>
                    <Grid container spacing={3} className="main-container">
                        <Grid item xs={12} sm={12}>
                            <Typography className={classes.question}>
                                Whether the company has revalued its Property, Plant and Equipment or intangible assets and, if so, whether
                                the evaluation is based on the valuation by a Registered Valuer; specify the amount of change, if change is
                                10% or more in the aggregate value
                            </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth>
                                <TextField
                                    label="Remarks"
                                    className="textfieldBottomLine mbtextField10"
                                    defaultValue="Enter Remarks"
                                    multiline
                                    rows={1}
                                />
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth>
                                <TextField
                                    label="Reporting"
                                    className="textfieldBottomLine mbtextField10"
                                    defaultValue="Enter Reporting"
                                    multiline
                                    rows={1}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControl className={classes.btnspace}>
                                <Button variant="outlined" color="primary" className={classes.button}>
                                    Attach document
                                </Button>
                            </FormControl>
                        </Grid>
                    </Grid>
                    <Grid container spacing={3} className="main-container">
                        <Grid item xs={12} sm={12}>
                            <Typography className={classes.question}>
                                Whether any proceedings have been initiated against the company for holding any benami property, if so,
                                whether the company has appropriately disclosed the details in its financial statements;
                            </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth>
                                <TextField
                                    label="Remarks"
                                    className="textfieldBottomLine mbtextField10"
                                    defaultValue="Enter Remarks"
                                    multiline
                                    rows={1}
                                />
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth>
                                <TextField
                                    label="Reporting"
                                    className="textfieldBottomLine mbtextField10"
                                    defaultValue="Enter Reporting"
                                    multiline
                                    rows={1}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControl className={classes.btnspace}>
                                <Button variant="outlined" color="primary" className={classes.button}>
                                    Attach document
                                </Button>
                            </FormControl>
                        </Grid>
                    </Grid>
                    <Grid container spacing={3} className="main-container">
                        <Grid item xs={12} sm={12}>
                            <Typography className={classes.question}>
                                Whether physical verification of inventory has been conducted at reasonable intervals by the management and
                                whether, the coverage and procedure of such verification by the management is appropriate; whether any
                                discrepancies of 10% or more in the aggregate for each class of inventory were noticed and if so, whether
                                they have been properly dealt with in the books of account;
                            </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControl component="fieldset">
                                <RadioGroup
                                    disabled
                                    defaultValue="Yes"
                                    aria-label="yes-no"
                                    name="customized-radios"
                                    className="radio-option mb15"
                                >
                                    <ul className={classes.inlineDisplay}>
                                        <li>
                                            <FormControlLabel value="Yes" control={<StyledRadio />} label="Yes" />
                                        </li>
                                        <li>
                                            <FormControlLabel value="No" control={<StyledRadio />} label="No" />
                                        </li>
                                        <li>
                                            <FormControlLabel value="NA" control={<StyledRadio />} label="NA" />
                                        </li>
                                    </ul>
                                </RadioGroup>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth>
                                <TextField
                                    label="Reporting"
                                    className="textfieldBottomLine mbtextField10"
                                    defaultValue="Enter Reporting"
                                    multiline
                                    rows={1}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth>
                                <TextField
                                    label="Remarks"
                                    className="textfieldBottomLine mbtextField10"
                                    defaultValue="Enter Remarks"
                                    multiline
                                    rows={1}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControl className={classes.btnspace}>
                                <Button variant="outlined" color="primary" className={classes.button}>
                                    Attach document
                                </Button>
                            </FormControl>
                        </Grid>
                    </Grid>
                    <Grid container spacing={3} className="main-container">
                        <Grid item xs={12} sm={12}>
                            <Typography className={classes.question}>
                                Has the management physically verified the inventory, as defined in AS 2/Ind AS 2? inventory normally
                                includes- Finished Goods, WIP and Raw Materials
                            </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth>
                                <TextField
                                    label="Remarks"
                                    className="textfieldBottomLine mbtextField10"
                                    defaultValue="Enter Remarks"
                                    multiline
                                    rows={1}
                                />
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth>
                                <TextField
                                    label="Reporting"
                                    className="textfieldBottomLine mbtextField10"
                                    defaultValue="Enter Reporting"
                                    multiline
                                    rows={1}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControl className={classes.btnspace}>
                                <Button variant="outlined" color="primary" className={classes.button}>
                                    Attach document
                                </Button>
                            </FormControl>
                        </Grid>
                    </Grid>
                    <Grid container spacing={3} className="main-container">
                        <Grid item xs={12} sm={12}>
                            <Typography className={classes.question}>
                                Whether evidence of physical verification has been seen and reasonableness of periodicity of physical
                                verification evaluated by verifying the Process and Documentation
                            </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth>
                                <TextField
                                    label="Remarks"
                                    className="textfieldBottomLine mbtextField10"
                                    defaultValue="Enter Remarks"
                                    multiline
                                    rows={1}
                                />
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth>
                                <TextField
                                    label="Reporting"
                                    className="textfieldBottomLine mbtextField10"
                                    defaultValue="Enter Reporting"
                                    multiline
                                    rows={1}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControl className={classes.btnspace}>
                                <Button variant="outlined" color="primary" className={classes.button}>
                                    Attach document
                                </Button>
                            </FormControl>
                        </Grid>
                    </Grid>
                    <Grid container spacing={3} className="main-container">
                        <Grid item xs={12} sm={12}>
                            <Typography className={classes.question}>
                                Whether the comparison of final inventories with stock has been done? Whether records and other
                                corroborative evidence, e.g. inventory statements submitted to banks?
                            </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth>
                                <TextField
                                    label="Remarks"
                                    className="textfieldBottomLine mbtextField10"
                                    defaultValue="Enter Remarks"
                                    multiline
                                    rows={1}
                                />
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth>
                                <TextField
                                    label="Reporting"
                                    className="textfieldBottomLine mbtextField10"
                                    defaultValue="Enter Reporting"
                                    multiline
                                    rows={1}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControl className={classes.btnspace}>
                                <Button variant="outlined" color="primary" className={classes.button}>
                                    Attach document
                                </Button>
                            </FormControl>
                        </Grid>
                    </Grid>
                    <Grid container spacing={3} className="main-container">
                        <Grid item xs={12} sm={12}>
                            <Typography className={classes.question}>
                                Whether company has working capital limits in excess of five crore rupees from banks or financial
                                institutions on the basis of security of current assets; whether the quarterly returns or statements filed
                                with such banks or financial institutions are in agreement with the books of account of the Company, if not,
                                give details;
                            </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControl component="fieldset">
                                <RadioGroup
                                    disabled
                                    defaultValue="Yes"
                                    aria-label="yes-no"
                                    name="customized-radios"
                                    className="radio-option mb15"
                                >
                                    <ul className={classes.inlineDisplay}>
                                        <li>
                                            <FormControlLabel value="Yes" control={<StyledRadio />} label="Yes" />
                                        </li>
                                        <li>
                                            <FormControlLabel value="No" control={<StyledRadio />} label="No" />
                                        </li>
                                        <li>
                                            <FormControlLabel value="NA" control={<StyledRadio />} label="NA" />
                                        </li>
                                    </ul>
                                </RadioGroup>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth>
                                <TextField
                                    label="Reporting"
                                    className="textfieldBottomLine mbtextField10"
                                    defaultValue="Enter Reporting"
                                    multiline
                                    rows={1}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth>
                                <TextField
                                    label="Remarks"
                                    className="textfieldBottomLine mbtextField10"
                                    defaultValue="Enter Remarks"
                                    multiline
                                    rows={1}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControl className={classes.btnspace}>
                                <Button variant="outlined" color="primary" className={classes.button}>
                                    Attach document
                                </Button>
                            </FormControl>
                        </Grid>
                    </Grid>
                    <Grid container spacing={3} className="main-container">
                        <Grid item xs={12} sm={12}>
                            <Typography className={classes.question}>
                                Whether the auditor using his professional judgement and considering the impact of the same on the financial
                                statements has dealt with the above discrepancies in his report; and has reported the same in such manner
                                that is understandable to the users of the financial statements.
                            </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth>
                                <TextField
                                    label="Remarks"
                                    className="textfieldBottomLine mbtextField10"
                                    defaultValue="Enter Remarks"
                                    multiline
                                    rows={1}
                                />
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth>
                                <TextField
                                    label="Reporting"
                                    className="textfieldBottomLine mbtextField10"
                                    defaultValue="Enter Reporting"
                                    multiline
                                    rows={1}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControl className={classes.btnspace}>
                                <Button variant="outlined" color="primary" className={classes.button}>
                                    Attach document
                                </Button>
                            </FormControl>
                        </Grid>
                    </Grid>
                    <Grid container spacing={3} className="main-container">
                        <Grid item xs={12} sm={12}>
                            <Typography className={classes.question}>
                                Whether during the year the company has made any Investment/ given guarantee
                            </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControl component="fieldset">
                                <RadioGroup
                                    disabled
                                    defaultValue="Yes"
                                    aria-label="yes-no"
                                    name="customized-radios"
                                    className="radio-option mb15"
                                >
                                    <ul className={classes.inlineDisplay}>
                                        <li>
                                            <FormControlLabel value="Yes" control={<StyledRadio />} label="Yes" />
                                        </li>
                                        <li>
                                            <FormControlLabel value="No" control={<StyledRadio />} label="No" />
                                        </li>
                                        <li>
                                            <FormControlLabel value="NA" control={<StyledRadio />} label="NA" />
                                        </li>
                                    </ul>
                                </RadioGroup>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth>
                                <TextField
                                    label="Reporting"
                                    className="textfieldBottomLine mbtextField10"
                                    defaultValue="Enter Reporting"
                                    multiline
                                    rows={1}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth>
                                <TextField
                                    label="Remarks"
                                    className="textfieldBottomLine mbtextField10"
                                    defaultValue="Enter Remarks"
                                    multiline
                                    rows={1}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControl className={classes.btnspace}>
                                <Button variant="outlined" color="primary" className={classes.button}>
                                    Attach document
                                </Button>
                            </FormControl>
                        </Grid>
                    </Grid>
                    <Grid container spacing={3} className="main-container">
                        <Grid item xs={12} sm={12}>
                            <Typography className={classes.question}>
                                Investments in, provided any guarantee or security or granted any loans or advances in the nature of loans,
                                secured or unsecured, to companies, firms, Limited Liability Partnerships or any other parties, if so, its
                                details
                            </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth>
                                <TextField
                                    label="Remarks"
                                    className="textfieldBottomLine mbtextField10"
                                    defaultValue="Enter Remarks"
                                    multiline
                                    rows={1}
                                />
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth>
                                <TextField
                                    label="Reporting"
                                    className="textfieldBottomLine mbtextField10"
                                    defaultValue="Enter Reporting"
                                    multiline
                                    rows={1}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControl className={classes.btnspace}>
                                <Button variant="outlined" color="primary" className={classes.button}>
                                    Attach document
                                </Button>
                            </FormControl>
                        </Grid>
                    </Grid>
                    <Grid container spacing={3} className="main-container">
                        <Grid item xs={12} sm={12}>
                            <Typography className={classes.question}>
                                Guarantees provided, security given and the terms and conditions of the grant of all loans and advances in
                                nature of loans and guarantees provided are not prejudicial to the company’s interes, if yes its details
                            </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth>
                                <TextField
                                    label="Remarks"
                                    className="textfieldBottomLine mbtextField10"
                                    defaultValue="Enter Remarks"
                                    multiline
                                    rows={1}
                                />
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth>
                                <TextField
                                    label="Reporting"
                                    className="textfieldBottomLine mbtextField10"
                                    defaultValue="Enter Reporting"
                                    multiline
                                    rows={1}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControl className={classes.btnspace}>
                                <Button variant="outlined" color="primary" className={classes.button}>
                                    Attach document
                                </Button>
                            </FormControl>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
            {/* Card 2 ends here */}
        </>
    );
};

export default CaroChecklist;
